import {ProductList} from "../components/ProductList";
import {useParams} from 'react-router-dom'
import SendMessageSection from "../components/SendMessageSection";
import {useRef} from "react";

function ProductPage() {
    const {type, id} = useParams()
    const messageRef = useRef(null);

    const onPlaceOrder = () => {
        messageRef?.current.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"})
    }

    return (
        <>
            <ProductList type={type} id={id} onPlaceOrder={onPlaceOrder}/>
            <SendMessageSection/>
            <div ref={messageRef}></div>
        </>
    );
}

export default ProductPage





